import { Component } from '@angular/core';
import { FormBuilder, Validators, FormsModule, FormGroup} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepperModule} from '@angular/material/stepper';
import { MatCardModule} from '@angular/material/card';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { CommonModule, NgFor} from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Company } from '../../intefaces/company.interface';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-add-company',
  standalone: false,

  templateUrl: './add-company.component.html',
  styleUrl: './add-company.component.scss'
})
export class AddCompanyComponent {
    companyDetals!: FormGroup;
    company!: Company;

    constructor(private fb: FormBuilder) {

    }

    ngOnInit(): void {
      this.companyDetals = this.fb.group({
        "address": new FormGroup(''),
        "email": new FormGroup(''),
        "name": new FormGroup(''),
        "countryCode": new FormGroup(''),
        "url": new FormGroup(''),
        "country": new FormGroup(''),
      });
    }

    onSubmit() {
      console.log(this.companyDetals);

    }
}
